module.exports = __webpack_public_path__ + "static/media/MZ_01.e9527a46.jpg";